// Set to true once billing/upgrade tiers are implemented
const UPGRADE_HINTS_ENABLED = false;

const defaultMetrics = {
  last_7d_login_count: 0,
  last_30d_login_count: 0,
  properties_count: 0,
  rent_events_logged: 0,
  compliance_docs_uploaded: 0,
  property_mot_interactions: 0,
  meaningful_actions_7d: 0,
  engagement_score: 0,
  engagement_version: 1,
  high_intent: false,
};

const DISMISSED_UPGRADE_HINTS_KEY = 'siyak.dismissedUpgradeHints.v1';

const getStoredDismissedPromptIds = () => {
  if (typeof window === 'undefined') return [];

  try {
    const raw = window.localStorage.getItem(DISMISSED_UPGRADE_HINTS_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed.filter((value) => typeof value === 'string') : [];
  } catch (_) {
    return [];
  }
};

export const dismissUpgradePrompt = (promptId) => {
  if (!promptId || typeof window === 'undefined') return;

  const nextValues = Array.from(new Set([...getStoredDismissedPromptIds(), promptId]));
  window.localStorage.setItem(DISMISSED_UPGRADE_HINTS_KEY, JSON.stringify(nextValues));
};

export const getDismissedUpgradePromptIds = () => getStoredDismissedPromptIds();

export const normalizeAccountMetrics = (metrics = {}) => ({
  ...defaultMetrics,
  ...(metrics || {}),
});

export const getUpgradePrompts = (metrics = {}, options = {}) => {
  if (!UPGRADE_HINTS_ENABLED) return [];

  const normalized = normalizeAccountMetrics(metrics);
  const justCreatedProperty = Boolean(options.justCreatedProperty);
  const dismissedIds = options.includeDismissed
    ? new Set()
    : new Set(getStoredDismissedPromptIds());
  const prompts = [];

  if (normalized.properties_count >= 2) {
    prompts.push({
      id: 'multi-property',
      placements: justCreatedProperty ? ['property-create', 'dashboard'] : ['dashboard'],
      message: "You're now managing multiple properties. Tools for tracking everything in one place are coming soon.",
      ctaLabel: "See what's coming",
    });
  }

  if (normalized.compliance_docs_uploaded >= 1 || normalized.property_mot_interactions >= 2) {
    prompts.push({
      id: 'compliance',
      placements: ['compliance', 'documents'],
      message: 'Keep all your property requirements organised and easy to track. Advanced tracking and reminders coming soon.',
      ctaLabel: "See what's coming",
    });
  }

  if (normalized.rent_events_logged >= 3) {
    prompts.push({
      id: 'rent',
      placements: ['rent'],
      message: 'Automate reminders and keep records organised — features like this are coming soon.',
      ctaLabel: "See what's coming",
    });
  }

  if (normalized.last_7d_login_count >= 3) {
    prompts.push({
      id: 'repeat-usage',
      placements: ['dashboard'],
      message: "You're actively managing your properties — more automation tools are on the way.",
      ctaLabel: "See what's coming",
    });
  }

  if (normalized.high_intent === true) {
    prompts.push({
      id: 'high-intent',
      placements: ['dashboard', 'navbar'],
      message: "You're getting the most out of Siyak. More advanced tools will be available soon.",
      ctaLabel: "See what's coming",
    });
  }

  return prompts.filter((prompt) => !dismissedIds.has(prompt.id));
};

export const getUpgradePromptsForPlacement = (metrics = {}, placement, options = {}) => (
  getUpgradePrompts(metrics, options).filter((prompt) => prompt.placements.includes(placement))
);
